import { Box, Button, MenuItem, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import InputField from '../../../../../components/customElements/InputField/InputField'
import { statusNotifications } from '../../../consts/notifications.data'
import { RequestType } from '../../../types/Request.type'
import { mapChipValue } from '../../../utils/mapChipValue'
import { mapSelectItems } from '../../../utils/mapSelectItems'
import DealersAutocomplete from '../elements/DealersAutocomplete'
import TypedAccordion from '../elements/TypedAccordion'
import WarnNotification from '../elements/WarnNotification'
import { useDrawerContentStatus } from '../hooks/useDrawerContentStatus'
import { menuItemSx, titleSx } from '../styles/styles'

type DrawerContentStatusProps = {
  request: RequestType
  onClose: () => void
}

export const DrawerContentStatus: React.FC<DrawerContentStatusProps> = ({
  request,
  onClose,
}) => {
  const intl = useIntl()
  const [showNotification, setShowNotification] = React.useState(true)
  const {
    items,
    value,
    onChange,
    shouldShowCommentField,
    comment,
    setComment,
    shouldSelectDealer,
    dealers,
    onDealerChange,
    dealerValue,
    onSave,
    disableSaveBtn,
    goBack,
  } = useDrawerContentStatus(request, onClose)

  return (
    <Stack height={'100%'} justifyContent={'space-between'}>
      <TypedAccordion summary={'Статус заявки'}>
        <Stack sx={{ padding: '16px' }}>
          {mapChipValue(request, 'status')}
        </Stack>
        <Stack
          sx={{ padding: '16px', borderTop: '1px solid #E0E0E0' }}
          spacing={'10px'}
        >
          <Typography variant='body2' sx={titleSx}>
            новый статус
          </Typography>
          <InputField
            type='select'
            name={intl.formatMessage({ id: 'Статус' })}
            items={mapSelectItems(items)}
            value={value}
            displayEmpty
            renderValue={(value: any) => {
              const item = items.find(
                (el: any) => el.id == value || value == el,
              )

              if (!item)
                return (
                  <Typography variant={'body2'} sx={placeholderSx}>
                    Выберите статус
                  </Typography>
                )

              return (
                <MenuItem value={item?.id} sx={menuItemSx}>
                  <img src={item?.imageSrc} />
                  <Typography variant='body1' sx={{ ml: '12px' }}>
                    {item?.name}
                  </Typography>
                </MenuItem>
              )
            }}
            onChange={onChange}
            territorySelect={false}
            FormControlSx={{ width: '100%' }}
            width='100%'
          />
        </Stack>
        {shouldShowCommentField && (
          <Stack sx={{ padding: '16px' }}>
            <InputField
              multiline
              value={comment}
              onChange={(e: React.ChangeEvent<any>) =>
                setComment(e.target.value)
              }
              rows={4}
              fullWidth
              territorySelect={false}
              placeholder={intl.formatMessage({ id: 'Введите комментарий' })}
            />
          </Stack>
        )}
        {shouldSelectDealer && (
          <DealersAutocomplete
            items={mapSelectItems(dealers)}
            onChange={onDealerChange}
            value={dealerValue}
            label='назначить на Дилера'
          />
        )}
        {showNotification && (
          <Stack sx={{ paddingX: '16px' }}>
            <WarnNotification
              notifications={statusNotifications}
              setIsShown={setShowNotification}
              title='Изменение статуса '
            />
          </Stack>
        )}
      </TypedAccordion>
      <Box px={2}>
        <Button
          color={'primary'}
          variant={'contained'}
          onClick={onSave}
          sx={{ margin: '24px 0 0 0' }}
          fullWidth
          disabled={disableSaveBtn}
        >
          <FormattedMessage id={'сохранить'} />
        </Button>
        <Button
          color={'primary'}
          variant={'outlined'}
          onClick={() => goBack()}
          fullWidth
          sx={{ margin: '8px 0 24px 0' }}
        >
          <FormattedMessage id={'Отмена'} />
        </Button>
      </Box>
    </Stack>
  )
}

const placeholderSx = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: '16px!important',
  lineHeight: '20px!important',
  color: 'rgba(0, 0, 0, 0.38)', // серый цвет для placeholder
}

export default observer(DrawerContentStatus)
